import { createStore } from "vuex";
import { user } from "./modules/user";
import { survey } from "./modules/survey";
export default createStore({
  modules: {
    user,
    survey,
  },
});
